// import OutdoorRecreation from 'elem/compPage/OutdoorRecreation';
import { GetServerSidePropsContext } from 'next';
import EFPicture from 'elem/compCommon/EFPicture';
import css from './index.module.scss';
import { redirectTo404 } from '@/utils';
import { useGlobal } from '@/utils/useGlobal';
import PageLayout from '@/components/PageLayout';
import SEO from '@/components/utils/SEO';
import SEOlinksA from '@/components/SEOlinksA';

export default function FinancingPage() {
    const { useRouter, useEffect, useLang } = useGlobal();
    const { t } = useLang('financing');
    const router = useRouter();
    const { locale } = router;

    return (
        <PageLayout isNoFixed theme="black">
            <SEO title={t('seo_title')} description={t('seo_desc')} />
            <SEOlinksA locale={String(locale)} list={['de']} pathname={'financing'} />
            <div className={`${css.financingBanner} banner-static`}>
                <EFPicture
                    src={'/responsive/picture/financing/1.jpg'}
                    srcPad={'/responsive/picture/financing/1_768.jpg'}
                    srcDesktop={'/responsive/picture/financing/1_1366.jpg'}
                    srcMobile={'/responsive/picture/financing/1_375.jpg'}
                    alt={'t'}
                    style={{ height: 'auto' }}
                />
                <div className="banner-box">
                    <div className="pic-wrapper">
                        <EFPicture
                            src={'/responsive/picture/financing/banner_icon.png'}
                            srcPad={'/responsive/picture/financing/banner_icon.png'}
                            srcDesktop={'/responsive/picture/financing/banner_icon.png'}
                            srcMobile={'/responsive/picture/financing/banner_icon.png'}
                            alt={'t'}
                            style={{ height: 'auto' }}
                        />
                    </div>
                    <div className="banner-title">{t('banner_title')}</div>
                    <div className="banner-desc">{t('banner_desc')}</div>
                    <div
                        className="banner-btn"
                        onClick={() => {
                            window.location.href = `https://www.consorsfinanz.de/lp/ecoflow`;
                        }}
                    >
                        {t('banner_button')}
                    </div>
                </div>
            </div>
        </PageLayout>
    );
}

export function getServerSideProps(ctx: GetServerSidePropsContext) {
    if (ctx.locale !== 'de') {
        return redirectTo404();
    }
    return {
        props: {},
    };
}
